import { faFloppyDisk, faAnglesLeft } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { ReactElement } from 'react';
import type { ModalConfig, TopBarElement, UnifiedTopBarProps } from '@frontend/Models/TopBar/TopBarModels';

export interface CreateFormTemplateOptions {
  onSave: () => void;
  onCancel: () => void;
  saveAriaLabel?: string;
  cancelAriaLabel?: string;
  saveIcon?: IconDefinition;
  cancelIcon?: IconDefinition;
  disableSave?: boolean;
  disableCancel?: boolean;
  rightExtras?: TopBarElement[];
  modals?: ModalConfig[];
  className?: string;
  pageContext?: Record<string, any>;
  title?: string;
  saveElement?: TopBarElement | ReactElement;
}

export function createCreateFormTemplate(options: CreateFormTemplateOptions): UnifiedTopBarProps {
  // Place the cancel action on the left and the primary save action on the right
  const leftElements: TopBarElement[] = [
    {
      type: 'button',
      icon: options.cancelIcon ?? faAnglesLeft,
      onClick: options.onCancel,
      ariaLabel: options.cancelAriaLabel ?? 'Cancel',
      disabled: options.disableCancel,
    },
  ];

  // Add title if provided
  if (options.title) {
    leftElements.push({
      type: 'text',
      text: options.title,
    });
  }

  // Provide the save action as a right element so it appears on the right side
  const defaultSaveElement: TopBarElement = {
    type: 'button',
    icon: options.saveIcon ?? faFloppyDisk,
    onClick: options.onSave,
    ariaLabel: options.saveAriaLabel ?? 'Save',
    label: options.saveAriaLabel ?? 'Save',
    disabled: options.disableSave,
  } as any;

  const rightElements = [
    ...(options.rightExtras ?? []),
    options.saveElement ?? defaultSaveElement,
  ];

  return {
    leftElements,
    rightElements,
    modals: options.modals ?? [],
    className: options.className,
    pageContext: options.pageContext,
  };
}
